import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

const useDeletePoolFile = () => {
  const fetchRequest = useFetch<{ success: boolean }>()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await fetchRequest(
        `${apiBase()}/files/${id}`,
        undefined,
        undefined,
        'DELETE',
      )
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' &&
          query.queryKey[0].startsWith('/files'),
      })
    },
  })
}

export default useDeletePoolFile
